export default __webpack_public_path__ + "static/media/help-laptop-img.91688db6.svg";